/*
  LAY "What's holding you back?" (cart-fix 1. resz). Leiras, szabalyok es a szovegek: snippets/lay-whyb.liquid.
  A drawer bezarasat a <dialog> nativ "close" esemenye jelzi (az animacio utan); hogy MI zarta be, azt a bezaras elotti
  utolso mozdulat mondja meg (X, hatter, Esc, Android vissza = megjelenhet; link, Check out, Shop Pay = nem).
  A 10-02-i zarhoz, a pillekhez, a kosar mukodesehez es a trackinghez nem nyul.
*/
(function () {
  'use strict';
  if (window.__layWhyb) return;
  window.__layWhyb = true;

  var dataEl = document.getElementById('lay-whyb-data');
  if (!dataEl) return;
  var D;
  try {
    D = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var KEY_SEEN = 'lay_whyb_seen'; /* sessionStorage: ebben a munkamenetben mar megjelent */
  var KEY_CO = 'lay_whyb_co'; /* sessionStorage: Check out / Shop Pay megnyomva */
  var KEY_DONE = 'lay_whyb_done'; /* localStorage: a valasz ideje (7 napig nem jon ujra) */
  var WEEK = 7 * 24 * 60 * 60 * 1000;
  var mem = {}; /* ha az IG/FB in-app bongeszo eldobja a tarolast, a lapon belul ez tartja */

  function sget(k) {
    try {
      var v = window.sessionStorage.getItem(k);
      if (v !== null) return v;
    } catch (e) {}
    return mem[k] || null;
  }
  function sset(k, v) {
    mem[k] = v;
    try {
      window.sessionStorage.setItem(k, v);
    } catch (e) {}
  }
  function lget(k) {
    try {
      return window.localStorage.getItem(k);
    } catch (e) {
      return null;
    }
  }
  function lset(k, v) {
    try {
      window.localStorage.setItem(k, v);
    } catch (e) {}
  }
  function clarity() {
    try {
      if (typeof window.clarity === 'function') window.clarity.apply(window, arguments);
    } catch (e) {}
  }

  function drawerEl() {
    return document.getElementById('cart-drawer');
  }
  function cartDialog() {
    var d = drawerEl(); /* <theme-drawer id="cart-drawer">, benne a <dialog class="theme-drawer__dialog"> */
    return d ? d.querySelector('dialog.theme-drawer__dialog') || d.querySelector('dialog') : null;
  }
  function cartThemeDrawer() {
    var d = drawerEl();
    return d ? d.closest('theme-drawer') : null;
  }

  /* --- Mi zarta be a drawert? --- */
  var intent = null;
  function mark(k) {
    intent = { k: k, t: Date.now() };
  }
  function onPointer(e) {
    var dlg = cartDialog();
    if (!dlg || !dlg.open) return;
    var t = e.target;
    if (!(t instanceof Element) || t.closest('.lay-whyb')) return;
    if (t !== dlg && dlg.contains(t)) {
      if (t.closest('.theme-drawer__close-button')) return mark('x');
      if (t.closest('[name="checkout"], .lay-shoppay, shopify-accelerated-checkout-cart')) {
        sset(KEY_CO, '1');
        return mark('nav');
      }
      if (t.closest('a[href], shopify-payment-terms')) return mark('nav');
      return;
    }
    if (t === dlg) return mark('backdrop'); /* mobil: a hatterre koppintas a dialogusra esik */
    if (t.closest('header-component')) return; /* fejlec (BAG-gomb): nem kerdezunk */
    mark('backdrop'); /* desktop: kattintas az oldalra (snippets/lay-top.liquid zarja) */
  }
  document.addEventListener('pointerdown', onPointer, true);
  document.addEventListener(
    'click',
    function (e) {
      if (e.detail === 0) onPointer(e); /* billentyuzetes aktivalas (Enter, Space) */
    },
    true
  );
  document.addEventListener(
    'keydown',
    function (e) {
      if (e.key !== 'Escape') return;
      var dlg = cartDialog();
      if (dlg && dlg.open) {
        mark('esc');
      } else if (sheetOpen) {
        dismiss();
      }
    },
    true
  );
  document.addEventListener(
    'cancel',
    function (e) {
      var dlg = cartDialog();
      if (!dlg || e.target !== dlg) return;
      if (!(intent && Date.now() - intent.t < 1000)) mark('back'); /* Android rendszer-vissza */
    },
    true
  );
  document.addEventListener(
    'close',
    function (e) {
      var dlg = cartDialog();
      if (!dlg || e.target !== dlg) return;
      var it = intent;
      intent = null;
      if (!it || it.k === 'nav' || Date.now() - it.t > 4000) return;
      window.setTimeout(maybeShow, 60);
    },
    true
  );
  document.addEventListener('theme-drawer:open', function () {
    if (sheetOpen) hide();
  });

  /* --- Megjelenhet-e? --- */
  function trimSlash(s) {
    s = String(s || '');
    while (s.length > 1 && s.charAt(s.length - 1) === '/') s = s.slice(0, -1);
    return s;
  }
  function onCartPage() {
    return trimSlash(window.location.pathname) === trimSlash((D.urls && D.urls.cart) || '/cart');
  }
  function hasItems() {
    var d = drawerEl();
    return !!(d && d.querySelector('.cart-items__title'));
  }
  function otherDialogOpen() {
    var drawer = drawerEl();
    var list = document.querySelectorAll('[role="dialog"], [aria-modal="true"], dialog[open]');
    for (var i = 0; i < list.length; i++) {
      var n = list[i];
      if (n.closest('.lay-whyb') || (drawer && (drawer.contains(n) || n.contains(drawer)))) continue;
      var r = n.getBoundingClientRect();
      if (r.width < 20 || r.height < 20) continue;
      var cs = window.getComputedStyle(n);
      if (cs.display === 'none' || cs.visibility === 'hidden' || Number(cs.opacity) === 0) continue;
      return true;
    }
    return false;
  }
  function maybeShow() {
    if (sheetOpen || onCartPage() || !hasItems()) return;
    if (sget(KEY_CO) === '1' || sget(KEY_SEEN) === '1') return;
    var done = Number(lget(KEY_DONE)) || 0;
    if (done && Date.now() - done < WEEK) return;
    if (otherDialogOpen()) return;
    show();
  }

  /* --- A lap --- */
  var el = null;
  var lineEl = null;
  var btnsEl = null;
  var chips = [];
  var changeEl = null;
  var sheetOpen = false;
  var answered = false; /* a lap most valaszt mutat */
  var current = null; /* a most mutatott ok */
  var recorded = false; /* az ELSO valasz mar a Claritybe ment (a "Change" utani atvaltas nem szamit) */
  var poll = null;
  var X_SVG =
    '<svg width="12" height="12" viewBox="0 0 12 12" aria-hidden="true" focusable="false"><path d="M1 1l10 10M11 1L1 11" stroke="currentColor" stroke-width="1.5" fill="none" stroke-linecap="round"/></svg>';

  function build() {
    el = document.createElement('div');
    el.className = 'lay-whyb';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'false');
    el.setAttribute('aria-labelledby', 'lay-whyb-q');
    el.hidden = true;

    var x = document.createElement('button');
    x.type = 'button';
    x.className = 'lay-whyb__x';
    x.setAttribute('aria-label', D.close || 'Close');
    var dlg = cartDialog();
    var icon = dlg ? dlg.querySelector('.theme-drawer__close-button svg') : null;
    x.innerHTML = icon ? icon.outerHTML : X_SVG;
    x.addEventListener('click', dismiss);

    var q = document.createElement('p');
    q.className = 'lay-whyb__q';
    q.id = 'lay-whyb-q';
    q.textContent = D.title;

    var group = document.createElement('div');
    group.className = 'lay-whyb__chips';
    group.setAttribute('role', 'group');
    group.setAttribute('aria-labelledby', 'lay-whyb-q');
    (D.reasons || []).forEach(function (r) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lay-whyb__chip';
      b.setAttribute('data-reason', r[0]);
      b.setAttribute('aria-pressed', 'false');
      b.textContent = r[1];
      b.addEventListener('click', function () {
        answer(r[0]);
      });
      chips.push(b);
      group.appendChild(b);
    });
    changeEl = document.createElement('button');
    changeEl.type = 'button';
    changeEl.className = 'lay-whyb__change';
    changeEl.textContent = (D.buttons && D.buttons.change) || 'Change';
    changeEl.addEventListener('click', reopen);
    group.appendChild(changeEl);

    var a = document.createElement('div');
    a.className = 'lay-whyb__a';
    lineEl = document.createElement('p');
    lineEl.className = 'lay-whyb__line';
    btnsEl = document.createElement('div');
    btnsEl.className = 'lay-whyb__btns';
    a.appendChild(lineEl);
    a.appendChild(btnsEl);

    el.appendChild(x);
    el.appendChild(q);
    el.appendChild(group);
    el.appendChild(a);
    document.body.appendChild(el);
  }

  function show() {
    if (!el) build();
    answered = false;
    current = null;
    recorded = false;
    el.classList.remove('is-answered');
    chips.forEach(function (c) {
      c.setAttribute('aria-pressed', 'false');
    });
    lineEl.textContent = '';
    btnsEl.textContent = '';
    el.hidden = false;
    sheetOpen = true;
    sset(KEY_SEEN, '1');
    void el.offsetWidth; /* a beuszas animaciohoz */
    el.classList.add('is-open');
    clarity('event', 'lay_whyb_shown');
    if (!poll) {
      poll = window.setInterval(function () {
        if (sheetOpen && otherDialogOpen()) hide(); /* pl. kozben feljon a Klaviyo-form: ne fedjek egymast */
      }, 700);
    }
  }

  function hide() {
    if (!el || !sheetOpen) return;
    sheetOpen = false;
    if (poll) {
      window.clearInterval(poll);
      poll = null;
    }
    el.classList.remove('is-open');
    window.setTimeout(function () {
      if (!sheetOpen) el.hidden = true;
    }, 280);
  }

  function dismiss() {
    if (!sheetOpen) return;
    if (!recorded) clarity('event', 'lay_whyb_dismiss');
    hide();
  }

  function answer(reason) {
    if (answered && reason === current) return;
    answered = true;
    current = reason;
    el.classList.add('is-answered');
    chips.forEach(function (c) {
      c.setAttribute('aria-pressed', String(c.getAttribute('data-reason') === reason));
    });
    fill(reason);
    if (!recorded) {
      recorded = true;
      clarity('set', 'lay_whyb', reason);
      clarity('event', 'lay_whyb_' + reason);
      lset(KEY_DONE, String(Date.now()));
    }
  }

  /* "Change": vissza mind az ot okhoz (a mar rogzitett elso valasz marad) */
  function reopen() {
    answered = false;
    current = null;
    el.classList.remove('is-answered');
    chips.forEach(function (c) {
      c.setAttribute('aria-pressed', 'false');
    });
    lineEl.textContent = '';
    btnsEl.textContent = '';
    if (chips[0]) {
      try {
        chips[0].focus({ preventScroll: true });
      } catch (e) {}
    }
  }

  function firstScent() {
    var d = drawerEl();
    var a = d ? d.querySelector('.cart-items__title[href]') : null;
    if (!a) return null;
    var href = String(a.getAttribute('href') || '');
    var at = href.indexOf('/products/');
    if (at < 0) return null;
    var h = href.slice(at + 10).split(/[?#/]/)[0];
    try {
      h = decodeURIComponent(h);
    } catch (e) {}
    if (D.scents && D.scents[h]) return h;
    if (h.indexOf('bundle-') === 0) {
      var k = h.slice(7).split('-')[0];
      return (D.keys && D.keys[k]) || null;
    }
    return null;
  }

  function fill(reason) {
    var L = D.lines || {};
    lineEl.textContent = '';
    btnsEl.textContent = '';
    if (reason === 'scent') {
      var h = firstScent();
      var s = h && D.scents ? D.scents[h] : null;
      lineEl.textContent = s
        ? String(L.scent).replace('{name}', s[0]).replace('{rating}', s[1]).replace('{count}', String(s[2]))
        : L.scent_all || '';
      btnsEl.appendChild(linkButton(D.urls.reviews + (s ? '#' + h : ''), D.buttons.reviews));
      btnsEl.appendChild(backButton(true));
      return;
    }
    if (reason === 'returns') {
      var parts = String(L.returns || '').split('{link}');
      lineEl.appendChild(document.createTextNode(parts[0] || ''));
      if (parts.length > 1) {
        var link = document.createElement('a');
        link.href = D.urls.refund;
        link.textContent = L.returns_link || 'Refund Policy';
        lineEl.appendChild(link);
        lineEl.appendChild(document.createTextNode(parts[1] || ''));
      }
    } else {
      lineEl.textContent = L[reason] || '';
    }
    btnsEl.appendChild(backButton(false));
  }

  function linkButton(href, label) {
    var a = document.createElement('a');
    a.className = 'lay-whyb__btn';
    a.href = href;
    a.textContent = label;
    return a;
  }

  function backButton(ghost) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'lay-whyb__btn' + (ghost ? ' lay-whyb__btn--ghost' : '');
    b.textContent = D.buttons.back;
    b.addEventListener('click', function () {
      hide();
      var td = cartThemeDrawer();
      if (td && typeof td.open === 'function') td.open();
    });
    return b;
  }
})();
